<h1 class="title">
  Bienvenue {{ form.get("name")?.value || '' }} !
  Commençons par saisir les données relatives à l'établissement
</h1>
<h5 class="title-text-muted text-muted fs-16">
  Ajoutez les détails essentiels de l'établissement pour garantir l'authenticité.
</h5>

<div class="row my-3">
  <app-custom-input
    cdkFocusInitial
    [label]="'Nom de l\'établissement de santé'"
    [placeholder]="'exemple : Centre Hospitalier Jean DUPONT'"
    [parentForm]="form"
    controlName="name"
    [required]="true"
  ></app-custom-input>
</div>

<div class="row my-3">
  <app-custom-input
    [label]="'Numéro SIRET'"
    [type]="'number'"
    [parentForm]="form"
    [errorMessage]="'Numéro SIRET doit avoir 14 chiffres'"
    controlName="numsiret"
    (input)="onSiretInputChange($event)"
    [placeholder]="'0'"
    [required]="true"
  ></app-custom-input>
</div>

<div class="row my-2">
  <app-custom-drop-down
    [parentForm]="form"
    controlName="typeetablissement"
    [label]="'Type de l’établissement'"
    [options]="etablissementType"
    [required]="true"
    [simpleDropDown]="true"
  ></app-custom-drop-down>
</div>

<div class="row my-2">
  <app-custom-input
    [parentForm]="form"
    controlName="nombresalaries"
    [type]="'number'"
    [label]="'Nombre de salariés approximatif'"
  ></app-custom-input>
</div>

<div class="row my-2">
  <app-custom-input
    [parentForm]="form"
    controlName="nombreannuelpatients"
    [label]="'Nombre annuel de patients pris en charge'"
    [type]="'number'"
  ></app-custom-input>
</div>

<div class="row my-3">
  <app-custom-input
    [label]="'Numéro FINESS'"
    [type]="'number'"
    [parentForm]="form"
    [errorMessage]="'Numéro FINESS doit avoir 9 chiffres'"
    controlName="numfiness"
    (input)="onFinessInputChange($event)"
    [placeholder]="'0'"
  ></app-custom-input>
</div>

<div class="row my-3">
  <app-custom-input
    [label]="'Description'"
    [type]="'textarea'"
    [parentForm]="form"
    controlName="description"
  ></app-custom-input>
</div>

<div class="row my-3">
  <mat-label>Choix de la gestion administrative de l’intérim</mat-label>
  <app-custom-checkbox
    [label]="'Par l’agence d’intérim'"
    [value]="'COLLARY'"
    [checked]="form.get('platformManagedBy')?.value === 'COLLARY'"
    (change)="checkBoxChange('COLLARY')"
  ></app-custom-checkbox>

  <app-custom-checkbox
    [label]="'Par votre établissement'"
    [value]="'YOURSELVES'"
    [checked]="form.get('platformManagedBy')?.value === 'YOURSELVES'"
    (change)="checkBoxChange('YOURSELVES')"
  ></app-custom-checkbox>
</div>
